/*@ngInject*/
export default ['IntlTelInput', (IntlTelInput) => (countryCode) => {
    return '+' + IntlTelInput.getCountryData().find((e) => e.iso2 == countryCode.toLowerCase()).dialCode;
}]


